import { cleanText } from './text.ts';

/** The 77 provinces of Thailand (official Thai names). */
export const THAI_PROVINCES = [
  'กรุงเทพมหานคร', 'กระบี่', 'กาญจนบุรี', 'กาฬสินธุ์', 'กำแพงเพชร', 'ขอนแก่น', 'จันทบุรี', 'ฉะเชิงเทรา', 'ชลบุรี', 'ชัยนาท',
  'ชัยภูมิ', 'ชุมพร', 'เชียงราย', 'เชียงใหม่', 'ตรัง', 'ตราด', 'ตาก', 'นครนายก', 'นครปฐม', 'นครพนม',
  'นครราชสีมา', 'นครศรีธรรมราช', 'นครสวรรค์', 'นนทบุรี', 'นราธิวาส', 'น่าน', 'บึงกาฬ', 'บุรีรัมย์', 'ปทุมธานี', 'ประจวบคีรีขันธ์',
  'ปราจีนบุรี', 'ปัตตานี', 'พระนครศรีอยุธยา', 'พะเยา', 'พังงา', 'พัทลุง', 'พิจิตร', 'พิษณุโลก', 'เพชรบุรี', 'เพชรบูรณ์',
  'แพร่', 'ภูเก็ต', 'มหาสารคาม', 'มุกดาหาร', 'แม่ฮ่องสอน', 'ยโสธร', 'ยะลา', 'ร้อยเอ็ด', 'ระนอง', 'ระยอง',
  'ราชบุรี', 'ลพบุรี', 'ลำปาง', 'ลำพูน', 'เลย', 'ศรีสะเกษ', 'สกลนคร', 'สงขลา', 'สตูล', 'สมุทรปราการ',
  'สมุทรสงคราม', 'สมุทรสาคร', 'สระแก้ว', 'สระบุรี', 'สิงห์บุรี', 'สุโขทัย', 'สุพรรณบุรี', 'สุราษฎร์ธานี', 'สุรินทร์', 'หนองคาย',
  'หนองบัวลำภู', 'อ่างทอง', 'อำนาจเจริญ', 'อุดรธานี', 'อุตรดิตถ์', 'อุทัยธานี', 'อุบลราชธานี',
] as const;

const ALIASES: Record<string, string> = {
  กรุงเทพ: 'กรุงเทพมหานคร',
  กรุงเทพฯ: 'กรุงเทพมหานคร',
  กทม: 'กรุงเทพมหานคร',
  'กทม.': 'กรุงเทพมหานคร',
  bangkok: 'กรุงเทพมหานคร',
  อยุธยา: 'พระนครศรีอยุธยา',
  โคราช: 'นครราชสีมา',
};

const key = (s: string) => s.replace(/\s+/g, '').toLowerCase();
const INDEX = new Map<string, string>([...THAI_PROVINCES.map((p) => [key(p), p] as [string, string]), ...Object.entries(ALIASES).map(([a, p]) => [key(a), p] as [string, string])]);

/**
 * Canonical province name, `''` for empty input, or `null` when the value is not
 * a Thai province. Accepts "จ.มหาสารคาม", "จังหวัด มหาสารคาม", common aliases.
 */
export function normalizeProvince(input: string | null | undefined): string | null {
  let s = cleanText(input);
  if (!s) return '';
  s = s.replace(/^จังหวัด\s*/u, '').replace(/^จ\.\s*/u, '');
  return INDEX.get(key(s)) ?? null;
}
